module.exports = __webpack_public_path__ + "img/Anna.575df688.png";